import { render } from "./VoiceRecorder.vue?vue&type=template&id=0e47a242"
import script from "./VoiceRecorder.vue?vue&type=script&lang=js"
export * from "./VoiceRecorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__